import React from 'react';
import { AuthForm } from '../../components/auth/AuthForm';
import { Link } from 'react-router-dom';
import { UserPlus } from 'lucide-react';
import { PageLayout } from '../../components/layout/PageLayout';
import { useTranslation } from '../../hooks/useTranslation';
import { SEO } from '../../components/seo/SEO';

export const Register = () => {
  const { t, getPathForLang } = useTranslation();

  return (
    <PageLayout disableAds={true}>
      <div className="min-h-screen bg-gray-50">
        <SEO
          title={t('auth.register.seo.title')}
          description={t('auth.register.seo.description')}
        />
        <div className="flex flex-col justify-center py-12 sm:px-6 lg:px-8">
          <div className="sm:mx-auto sm:w-full sm:max-w-md">
            <div className="flex justify-center">
              <div className="w-12 h-12 bg-indigo-100 rounded-xl flex items-center justify-center">
                <UserPlus className="w-6 h-6 text-indigo-600" />
              </div>
            </div>
            <h2 className="mt-4 text-center text-2xl sm:text-3xl font-bold text-gray-900">
              {t('auth.register.title')}
            </h2>
            <p className="mt-2 text-center text-sm text-gray-600">
              {t('auth.register.have_account')}{' '}
              <Link
                to={getPathForLang('/login')}
                className="font-medium text-indigo-600 hover:text-indigo-500"
              >
                {t('auth.register.sign_in')}
              </Link>
            </p>
          </div>

          <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
            <div className="bg-white py-8 px-4 shadow-xl sm:rounded-lg sm:px-10">
              <AuthForm mode="register" />
            </div>
          </div>
        </div>
      </div>
    </PageLayout>
  );
};